import React, { Component } from 'react';
import Comment from '../../../../common/comments/comment.component';
import { MAX_LENGTH } from '../../../../../constants/external-constants'
import { Loading } from '../../../../common/loading';
import { invoiceCommentActions } from '../../../../../store/external/invoice/invoice/invoice-comments.reducer';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

class InvoiceCommentsComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false
        }

    }

    componentDidMount() {
        const { getInvoiceDetailsComments } = this.props;
        getInvoiceDetailsComments(this.props.invoiceDetailsId)
            .then(() => {
                this.setState({ isLoading: false })
            });
    }

    postComment(attachedFilename, attachedFileData, commentDescription) {
        const { postInvoiceDetailsComments, getInvoiceDetailsComments } = this.props;
        postInvoiceDetailsComments(this.props.invoiceDetailsId, attachedFilename, attachedFileData, commentDescription);
        getInvoiceDetailsComments(this.props.invoiceDetailsId)
            .then(() => {
                this.setState({ isLoading: false })
            });
    }

    handleDeleteInvoiceComments = async (invoiceDetailsId) => {
        this.setState({ isLoading: true });
        const { deleteInvoiceDetailsComments, getInvoiceDetailsComments } = this.props;
        await deleteInvoiceDetailsComments(invoiceDetailsId, this.props.invoiceDetailsId);
        await getInvoiceDetailsComments(this.props.invoiceDetailsId).then(() => {
            this.setState({ isLoading: false })
        });
        this.setState({ show: false })
    }

    render() {

        if(this.state.isLoading){
            return <Loading />
        }

        const { roles } = this.props

        return (
            <>
                <Comment
                    commentList={this.props.invoiceInvoiceComments.InvoiceDetailsComments}
                    addCommentAction={this.postComment.bind(this)}
                    deleteCommentAction={this.handleDeleteInvoiceComments.bind(this)}
                    maxLength={MAX_LENGTH.limit_500}
                    isInvoiceComment={true}
                    {...roles}
                />
            </>
        );
    }
}


export default connect(
    state => {
        const { invoiceInvoiceComments } = state;
        return {
            invoiceInvoiceComments
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, invoiceCommentActions),
        dispatch
    )
)(InvoiceCommentsComponent);